import React from 'react'

const useDebouncedState = <T>(initialValue: T, delay: number) => {
  const [state, setState] = React.useState<T>(initialValue)
  const timerRef = React.useRef<NodeJS.Timeout>(null)

  const update = React.useCallback(
    (newValue: T) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }

      timerRef.current = setTimeout(() => {
        setState(newValue)
      }, delay)
    },
    [delay]
  )

  return [state, update] as [T, typeof update]
}

export default useDebouncedState
